import * as i0 from '@angular/core';
import { Injectable, EventEmitter, ElementRef, Component, Inject, ViewChild, Output, Input, HostListener, NgModule } from '@angular/core';
import * as i1 from '@upr-web-primer/lock-scroll';
import { LockScrollModule } from '@upr-web-primer/lock-scroll';
import { Subject } from 'rxjs';
import * as i2 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
import { get } from 'lodash-es';
import * as i3 from '@angular/cdk/a11y';
import { A11yModule } from '@angular/cdk/a11y';
const _c0 = ["closeBtn"];
const _c1 = ["modalRef"];
const _c2 = [[["", 8, "modal-header"]], [["", 8, "modal-body"]], [["", 8, "modal-footer"]], "*"];
const _c3 = [".modal-header", ".modal-body", ".modal-footer", "*"];
const _c4 = a0 => ({
  hideModal: a0
});
class AppModalService {
  constructor(lockscroll) {
    this.lockscroll = lockscroll;
    this.appModal$ = new Subject();
  }
  /**
   * Show any modal attached to the `appModal$` subscription.
   * @param config any data structure needed within current app.
   */
  show(config) {
    this.lockscroll.lockScroll();
    this.appModal$.next(config);
  }
  /**
   * Hide any modal attached to the `appModal$` subscription.
   * @param config any data structure needed within current app.
   */
  hide() {
    this.lockscroll.unlockScroll();
    this.appModal$.next({
      show: false
    });
  }
  static {
    this.ɵfac = function AppModalService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AppModalService)(i0.ɵɵinject(i1.LockScrollService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AppModalService,
      factory: AppModalService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AppModalService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.LockScrollService
  }], null);
})();
class ModalComponent {
  constructor(document, lockScrollSrv, renderer, zone) {
    this.document = document;
    this.lockScrollSrv = lockScrollSrv;
    this.renderer = renderer;
    this.zone = zone;
    this.closeModalEvent = new EventEmitter();
    this.allowOutsideClick = false;
  }
  keyup(event) {
    if (event.keyCode === 27) {
      this.closeModal();
    }
  }
  ngOnInit() {
    this.hideModal = typeof this.show === 'undefined' ? true : !this.show;
    if (!this.closeText) {
      this.closeText = 'Close';
    }
  }
  ngAfterContentInit() {
    if (this.modalRef) {
      this.zone.runOutsideAngular(() => {
        setTimeout(() => {
          if (this.closeBtn?.nativeElement) {
            this.closeBtn.nativeElement.focus();
          }
        }, 0);
      });
      const nodes = get(this.modalRef, 'nativeElement.parentElement.childNodes', []);
      nodes.forEach(node => {
        const className = get(node, 'className', '');
        // Check for the classes from CDK added to the DOM at runtime, example: cdk-visually-hidden cdk-focus-trap-anchor
        if (className.includes('cdk')) {
          this.renderer.setAttribute(node, 'tabindex', '-1');
        }
      });
    }
  }
  openModal() {
    if (!this.activatedEle) {
      this.activatedEle = this.document.activeElement;
    }
    this.hideModal = false;
    this.zone.runOutsideAngular(() => {
      setTimeout(() => {
        if (this.closeBtn && this.closeBtn.nativeElement) {
          this.closeBtn.nativeElement.focus();
        }
      }, 0);
    });
  }
  closeModal($event) {
    if ($event && (!$event.target.classList.contains('uo-modal') || !this.allowOutsideClick)) {
      return;
    }
    this.hideModal = true;
    if (this.closeModalEvent) {
      this.closeModalEvent.emit();
    }
    this.lockScrollSrv.unlockScroll();
    if (this.activatedEle) {
      this.activatedEle.focus();
      this.activatedEle = null;
    }
  }
  ngOnDestroy() {
    this.lockScrollSrv.unlockScroll();
  }
  static {
    this.ɵfac = function ModalComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ModalComponent)(i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.LockScrollService), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.NgZone));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ModalComponent,
      selectors: [["upr-modal"]],
      viewQuery: function ModalComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 7, ElementRef);
          i0.ɵɵviewQuery(_c1, 7, ElementRef);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.closeBtn = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.modalRef = _t.first);
        }
      },
      hostBindings: function ModalComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keyup", function ModalComponent_keyup_HostBindingHandler($event) {
            return ctx.keyup($event);
          }, false, i0.ɵɵresolveDocument);
        }
      },
      inputs: {
        modalHeight: "modalHeight",
        modalWidth: "modalWidth",
        show: "show",
        closeText: "closeText",
        allowOutsideClick: "allowOutsideClick"
      },
      outputs: {
        closeModalEvent: "closeModalEvent"
      },
      standalone: false,
      ngContentSelectors: _c3,
      decls: 11,
      vars: 7,
      consts: [["modalRef", ""], ["modalContent", ""], ["closeBtn", ""], ["id", "uoModal", "data-aui", "uo-modal", "role", "dialog", "aria-modal", "true", "aria-label", "Modal", 1, "uo-modal", 3, "click", "ngClass"], ["cdkTrapFocus", "", 1, "modal-content"], ["tabindex", "0", 1, "close", "font-20", 3, "click"], [1, "icon", "icon-close"]],
      template: function ModalComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵprojectionDef(_c2);
          i0.ɵɵelementStart(0, "div", 3, 0);
          i0.ɵɵlistener("click", function ModalComponent_Template_div_click_0_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.closeModal($event));
          });
          i0.ɵɵelementStart(2, "div", 4, 1);
          i0.ɵɵprojection(4);
          i0.ɵɵelementStart(5, "button", 5, 2);
          i0.ɵɵlistener("click", function ModalComponent_Template_button_click_5_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.closeModal());
          });
          i0.ɵɵelement(7, "i", 6);
          i0.ɵɵelementEnd();
          i0.ɵɵprojection(8, 1);
          i0.ɵɵprojection(9, 2);
          i0.ɵɵprojection(10, 3);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c4, ctx.hideModal));
          i0.ɵɵadvance(2);
          i0.ɵɵstyleProp("height", ctx.modalHeight, "%");
          i0.ɵɵadvance(3);
          i0.ɵɵattribute("aria-label", ctx.closeText || "Close Modal");
          i0.ɵɵadvance(2);
          i0.ɵɵattribute("aria-hidden", true);
        }
      },
      dependencies: [i2.NgClass, i3.CdkTrapFocus],
      styles: [".outline-style-primary-blue[_ngcontent-%COMP%]{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white[_ngcontent-%COMP%]{outline:1px dashed #fff;outline-offset:2px}.font-12[_ngcontent-%COMP%]{font-size:12px!important}.font-14[_ngcontent-%COMP%]{font-size:14px!important}.font-16[_ngcontent-%COMP%]{font-size:16px!important}.font-18[_ngcontent-%COMP%]{font-size:18px!important}.font-20[_ngcontent-%COMP%]{font-size:20px!important}.font-22[_ngcontent-%COMP%]{font-size:22px!important}.font-24[_ngcontent-%COMP%]{font-size:24px!important}.font-26[_ngcontent-%COMP%]{font-size:26px!important}.font-28[_ngcontent-%COMP%]{font-size:28px!important}.font-30[_ngcontent-%COMP%]{font-size:30px!important}.font-32[_ngcontent-%COMP%]{font-size:32px!important}.fade-me-in[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_fadeIn .25s;-webkit-animation:_ngcontent-%COMP%_fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0}to{opacity:1}}.uo-modal[_ngcontent-%COMP%]{display:block;position:fixed;z-index:1002;left:0;top:0;width:100%;height:100%;overflow:auto;background-color:#0006}.uo-modal.hideModal[_ngcontent-%COMP%]{display:none}.uo-modal[_ngcontent-%COMP%]   .modal-content[_ngcontent-%COMP%]{background-color:#fff;margin:70px auto auto;padding:20px;border:1px solid #dbdbdb;overflow:auto}@media print,screen and (min-width: 64em){.uo-modal[_ngcontent-%COMP%]   .modal-content[_ngcontent-%COMP%]{max-width:1050px}}.uo-modal[_ngcontent-%COMP%]   .close[_ngcontent-%COMP%]{color:#dbdbdb;position:absolute;top:25px;right:25px;font-size:28px;font-weight:700;cursor:pointer}.uo-modal[_ngcontent-%COMP%]   .close[_ngcontent-%COMP%]:hover, .uo-modal[_ngcontent-%COMP%]   .close[_ngcontent-%COMP%]:focus{color:#333;text-decoration:none}.uo-modal[_ngcontent-%COMP%]   .close[_ngcontent-%COMP%]:focus{outline:1px dashed #fff!important}@media print,screen and (max-width: 63.99875em){.uo-modal[_ngcontent-%COMP%]   .bottom-buttons[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]:first-of-type{order:2}}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalComponent, [{
    type: Component,
    args: [{
      selector: 'upr-modal',
      standalone: false,
      template: "<div\r\n\tid=\"uoModal\"\r\n\tclass=\"uo-modal\"\r\n\tdata-aui=\"uo-modal\"\r\n\trole=\"dialog\"\r\n\taria-modal=\"true\"\r\n\t[ngClass]=\"{ hideModal: hideModal }\"\r\n\t#modalRef\r\n\taria-label=\"Modal\"\r\n\t(click)=\"closeModal($event)\"\r\n>\r\n\t<div\r\n\t\tclass=\"modal-content\"\r\n\t\t#modalContent\r\n\t\tcdkTrapFocus\r\n\t\t[style.height.%]=\"modalHeight\"\r\n\t>\r\n\t\t<ng-content select=\".modal-header\"> </ng-content>\r\n\t\t<button\r\n\t\t\tclass=\"close font-20\"\r\n\t\t\t(click)=\"closeModal()\"\r\n\t\t\ttabindex=\"0\"\r\n\t\t\t#closeBtn\r\n\t\t\t[attr.aria-label]=\"closeText || 'Close Modal'\"\r\n\t\t>\r\n\t\t\t<i [attr.aria-hidden]=\"true\" class=\"icon icon-close\"> </i>\r\n\t\t</button>\r\n\t\t<ng-content select=\".modal-body\"> </ng-content>\r\n\t\t<ng-content select=\".modal-footer\"> </ng-content>\r\n\t\t<ng-content></ng-content>\r\n\t</div>\r\n</div>\r\n",
      styles: [".outline-style-primary-blue{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white{outline:1px dashed #fff;outline-offset:2px}.font-12{font-size:12px!important}.font-14{font-size:14px!important}.font-16{font-size:16px!important}.font-18{font-size:18px!important}.font-20{font-size:20px!important}.font-22{font-size:22px!important}.font-24{font-size:24px!important}.font-26{font-size:26px!important}.font-28{font-size:28px!important}.font-30{font-size:30px!important}.font-32{font-size:32px!important}.fade-me-in{animation:fadeIn .25s;-webkit-animation:fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.uo-modal{display:block;position:fixed;z-index:1002;left:0;top:0;width:100%;height:100%;overflow:auto;background-color:#0006}.uo-modal.hideModal{display:none}.uo-modal .modal-content{background-color:#fff;margin:70px auto auto;padding:20px;border:1px solid #dbdbdb;overflow:auto}@media print,screen and (min-width: 64em){.uo-modal .modal-content{max-width:1050px}}.uo-modal .close{color:#dbdbdb;position:absolute;top:25px;right:25px;font-size:28px;font-weight:700;cursor:pointer}.uo-modal .close:hover,.uo-modal .close:focus{color:#333;text-decoration:none}.uo-modal .close:focus{outline:1px dashed #fff!important}@media print,screen and (max-width: 63.99875em){.uo-modal .bottom-buttons .btn:first-of-type{order:2}}\n"]
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }, {
    type: i1.LockScrollService
  }, {
    type: i0.Renderer2
  }, {
    type: i0.NgZone
  }], {
    closeBtn: [{
      type: ViewChild,
      args: ['closeBtn', {
        read: ElementRef,
        static: true
      }]
    }],
    modalRef: [{
      type: ViewChild,
      args: ['modalRef', {
        read: ElementRef,
        static: true
      }]
    }],
    closeModalEvent: [{
      type: Output
    }],
    modalHeight: [{
      type: Input
    }],
    modalWidth: [{
      type: Input
    }],
    show: [{
      type: Input
    }],
    closeText: [{
      type: Input
    }],
    allowOutsideClick: [{
      type: Input
    }],
    keyup: [{
      type: HostListener,
      args: ['document:keyup', ['$event']]
    }]
  });
})();
class ModalModule {
  static {
    this.ɵfac = function ModalModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ModalModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ModalModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, LockScrollModule, A11yModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, LockScrollModule, A11yModule],
      declarations: [ModalComponent],
      exports: [ModalComponent]
    }]
  }], null, null);
})();

/*
 * Public API Surface of modal
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AppModalService, ModalComponent, ModalModule };
